import React, { useState } from "react";
import RechargePlans from "./RechargePlans";

const MobileRecharge1 = () => {
  const [showPlans, setShowPlans] = useState(false);
  const [enteredMobile, setEnteredMobile] = useState("");

  const [formData, setFormData] = useState({
    mobileNumber: "",
    operator: "",
    circle: "",
  });
  const [error, setError] = useState("");

  const circleOptions = [
    { value: "AP", label: "Andhra Pradesh, Telangana Region" },
    { value: "AS", label: "Assam Region" },
    { value: "BR", label: "Bihar, Jharkhand Region" },
    { value: "CH", label: "Chennai Region" },
    { value: "DL", label: "Delhi NCR Region" },
    { value: "GJ", label: "Gujarat Region" },
    { value: "HR", label: "Haryana Region" },
    { value: "HP", label: "Himachal Pradesh Region" },
    { value: "JK", label: "Jammu Kashmir Region" },
    { value: "KN", label: "Karnataka Region" },
    { value: "KL", label: "Kerala Region" },
    { value: "KO", label: "Kolkata Region" },
    { value: "MP", label: "Madhya Pradesh, Chhattisgarh Region" },
    { value: "MH", label: "Maharashtra, Goa Region" },
    { value: "MU", label: "Mumbai Region" },
    { value: "NE", label: "North East Region" },
    { value: "OR", label: "Orissa Region" },
    { value: "PB", label: "Punjab Region" },
    { value: "RJ", label: "Rajasthan Region" },
    { value: "TN", label: "Tamil Nadu Region" },
    { value: "UE", label: "UP East Region" },
    { value: "UW", label: "UP West Region" },
    { value: "WB", label: "West Bengal Region" }
  ];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "mobileNumber") {
      setEnteredMobile(value);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { mobileNumber, operator, circle } = formData;

    if (!mobileNumber || !operator || !circle) {
      setError("Please fill all fields");
      return;
    }

    if (mobileNumber.length !== 10) {
      setError("Mobile number must be 10 digits");
      return;
    }

    setError("");
    setShowPlans(true);
  };

  const handleClear = () => {
    setFormData({ mobileNumber: "", operator: "", circle: "" });
    setError("");
  };

  return (
    <div className="w-full">

      <div className="bg-white rounded-2xl shadow-md border p-6">

        {/* HEADER */}
        <div className="mb-6">
          <h3 className="text-lg font-semibold text-[#1F2A44]">
            Browse Mobile Plans
          </h3>
          <p className="text-sm text-gray-500">
            Enter details to fetch available recharge plans
          </p>
        </div>


        {/* FORM CARD */}
        {!showPlans && (
          <>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* MOBILE */}
              <div>
                <label className="text-xs font-semibold text-gray-600">
                  Mobile Number
                </label>

                <input
                  type="text"
                  name="mobileNumber"
                  maxLength="10"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="Enter 10 digit number"
                  className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                />
              </div>


              {/* OPERATOR */}
              <div>
                <label className="text-xs font-semibold text-gray-600">
                  Operator
                </label>

                <select
                  name="operator"
                  value={formData.operator}
                  onChange={handleChange}
                  className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="">Select Operator</option>

                  <option value="Airtel">Airtel</option>
                  <option value="RelianceJIO">Jio</option>
                  <option value="Vodafone">Vodafone</option>
                  <option value="BSNL">BSNL</option>
                  <option value="Idea">Idea</option>
                </select>
              </div>


              {/* CIRCLE */}
              <div className="md:col-span-2">
                <label className="text-xs font-semibold text-gray-600">
                  Circle
                </label>

                <select
                  name="circle"
                  value={formData.circle}
                  onChange={handleChange}
                  className="w-full mt-1 px-4 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 outline-none"
                >
                  <option value="">Select Circle</option>

                  {circleOptions.map((c) => (
                    <option key={c.value} value={c.value}>
                      {c.label}
                    </option>
                  ))}
                </select>
              </div>

            </div>

            {error && (
              <p className="text-red-500 text-sm mt-3">
                {error}
              </p>
            )}


            {/* BUTTONS */}
            <div className="flex gap-3 mt-6">

              <button
                type="button"
                onClick={handleClear}
                className="px-5 py-2 rounded-lg border border-[#12345A] text-[#12345A] 
  hover:bg-[#12345A] hover:text-white transition"
              >
                Clear
              </button>

              <button
                type="submit"
                onClick={handleSubmit}
                className="px-6 py-2 rounded-lg font-semibold text-white bg-[#12345A] 
  border border-[#12345A] hover:bg-white hover:text-[#12345A] transition"
              >
                Fetch Plans
              </button>

            </div>
          </>
        )}


        {/* PLANS SECTION */}
        {showPlans && (
          <div className="mt-6 p-6">

            <RechargePlans
              operator={formData.operator}
              mobileNumber={enteredMobile}
              circle={formData.circle}
              onBack={() => setShowPlans(false)}
            />

          </div>
        )}

      </div>

    </div>
  );
};

export default MobileRecharge1;
